import type {
  CreateDepartmentInput,
  DataResponse,
  Department,
  PaginatedResponse,
  PaginationQuery,
  UpdateDepartmentInput,
} from '@pms/shared';
import { api } from '@/lib/api';

export const departmentsService = {
  async list(query: Partial<PaginationQuery> = {}): Promise<PaginatedResponse<Department>> {
    const res = await api.get<PaginatedResponse<Department>>('/departments', { params: query });
    return res.data;
  },

  async get(id: string): Promise<Department> {
    const res = await api.get<DataResponse<Department>>(`/departments/${id}`);
    return res.data.data;
  },

  async create(input: CreateDepartmentInput): Promise<{ id: string }> {
    const res = await api.post<DataResponse<{ id: string }>>('/departments', input);
    return res.data.data;
  },

  async update(id: string, input: UpdateDepartmentInput): Promise<void> {
    await api.patch(`/departments/${id}`, input);
  },

  async deactivate(id: string): Promise<void> {
    await api.delete(`/departments/${id}`);
  },
};
